<template>
  <div class="tab-content home-content">
    <!-- 1-A: 首页主视图 -->
    <div v-if="homeSubPage === 'main'" class="home-page">
      <!-- Hero 核心区域 -->
      <section class="hero-section">
        <div class="hero-container">
          <h1 class="main-title">{{ t('home.heroTitle') }}</h1>
          
          <div class="info-card">
            <p class="intro-text">
              {{ t('home.introText') }}
            </p>
            
            <div class="philosophy-section">
              <span class="philosophy-title">{{ t('home.philosophyTitle') }}：</span>
              <span class="philosophy-text">
                {{ t('home.ph1') }} <span class="dot">·</span> 
                {{ t('home.ph2') }} <span class="dot">·</span> 
                {{ t('home.ph3') }} <span class="dot">·</span> 
                {{ t('home.ph4') }}
              </span>
            </div>
          </div>
        </div>
      </section>

      <!-- 3 大优势区域 -->
      <section class="features">
        <div class="container">
          <h2>{{ t('home.featuresTitle') }}</h2>
          <p class="section-description">{{ t('home.featuresSubTitle') }}</p>
          
          <div class="features-grid">
            <div v-for="(item, index) in featureList" :key="index" class="feature-card">
              <div class="feature-icon">{{ item.icon }}</div>
              <h3>{{ item.title }}</h3>
              <p>{{ item.desc }}</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 底部：关于我们跳转入口卡片 -->
      <section class="about-entrance-section">
        <div class="about-entrance-card" @click="homeSubPage = 'about'">
          <div class="entrance-info">
            <h3>{{ t('about.title') }}</h3>
            <p>{{ t('about.subtitle') }}</p>
          </div>
          <div class="entrance-btn">
            <span>{{ t('home.btnAboutUs') }}</span>
            <i class="el-icon-arrow-right"></i>
          </div>
        </div>
      </section>
    </div>

    <!-- 1-B: 关于我们二级全屏页面 -->
    <div v-else-if="homeSubPage === 'about'" class="about-page">
      <div class="about-nav-header">
        <button class="back-btn" @click="homeSubPage = 'main'">
          <i class="el-icon-back"></i> {{ t('about.backBtn') }}
        </button>
      </div>
      <main class="main-content">
        <section class="about-section">
          <div class="about-container">
            <h1>{{ t('about.title') }}</h1>
            <p class="subtitle">{{ t('about.subtitle') }}</p>
            
            <div class="about-content">
              <div class="about-text">
                <h2>{{ t('about.storyTitle') }}</h2>
                <p>{{ t('about.storyContent') }}</p>
                
                <h2>{{ t('about.philosophyTitle') }}</h2>
                <p>{{ t('about.philosophyContent') }}</p>
              </div>
              
              <div class="team-section">
                <h2>{{ t('about.teamTitle') }}</h2>
                <div class="team-grid">
                  <div class="team-card">
                    <div class="avatar-placeholder"></div>
                    <h3>Leo CHAN</h3>
                    <p class="role">Sales Manager</p>
                    <p class="bio">{{ t('about.team.leoBio') }}</p>
                  </div>
                  
                  <div class="team-card">
                    <div class="avatar-placeholder"></div>
                    <h3>Oscar LAW</h3>
                    <p class="role">Service Manager</p>
                    <p class="bio">{{ t('about.team.oscarBio') }}</p>
                  </div>
                  
                  <div class="team-card">
                    <div class="avatar-placeholder"></div>
                    <h3>Tommy LU</h3>
                    <p class="role">Business Manager</p>
                    <p class="bio">{{ t('about.team.tommyBio') }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  </div>
</template>

<script>
import i18nData from '@/i18n/locales.js'

export default {
  name: 'HomeTab',
  props: {
    lang: {
      type: String,
      default: 'zh'
    }
  },
  data() {
    return {
      homeSubPage: 'main',
      i18n: i18nData
    }
  },
  computed: {
    featureList() {
      return [
        { icon: '⚡', title: this.t('adv1Title'), desc: this.t('adv1Desc') },
        { icon: '🌐', title: this.t('adv2Title'), desc: this.t('adv2Desc') },
        { icon: '🛡️', title: this.t('adv3Title'), desc: this.t('adv3Desc') }
      ]
    }
  },
  methods: {
    t(key) {
      const keys = key.split('.')
      let val = this.i18n[this.lang]
      for (const k of keys) {
        if (val && val[k] !== undefined) {
          val = val[k]
        } else {
          return key
        }
      }
      return val
    }
  }
}
</script>

<style scoped>
@import '../assets/styles/home.css';
</style>